import React, { Component } from 'react'

export default function IndustryField({ value, name, id, onChange, disabled }) {
  return <div>Toimialavalikko</div>
}
